import AgentUsageCard from '@/components/agent-usage-card';
import NoneChip from '@/components/chip/none-chip';
import PolicyUsageCard from '@/components/policy-usage-card';
import { ModelUsage } from '@/lib/services/private-model.service';
import { Stack } from '@mui/material';
import { FC } from 'react';

interface Props {
  usage: ModelUsage;
}

const PrivateModelUsage: FC<Props> = ({ usage }) => {
  const { policies, agents, inUse } = usage;
  const hasPolicies = !!policies.length;
  const hasAgents = !!agents.length;

  if (!inUse) {
    return <NoneChip />;
  }

  return (
    <Stack gap={2}>
      {hasPolicies && (
        <PolicyUsageCard policies={policies} policyLinkScrollId="portal-private-model-settings" />
      )}
      {hasAgents && <AgentUsageCard agents={agents} />}
    </Stack>
  );
};

export default PrivateModelUsage;
